import directives from './module';
import intercom from '../intercom';
import { Utils } from 'underscore-extensions';

class FooterCtrl {
    intercom = intercom;
    isLangMenuHide = 'ontouchstart' in document.documentElement;
    date = new Date();
    product: AnimatronProduct;
    affUrl = `https://animatron${
        options.isProduction ? '' : 'test'
    }.tapfiliate.com/`;
    socials: SocialLink[] = [
        {
            href: 'github',
            className: 'gh'
        },
        {
            href: 'facebook',
            className: 'fb'
        },
        {
            href: 'youtube',
            className: 'yt'
        },
        {
            href: 'twitter',
            className: 'tw'
        },
        {
            href: 'instagram',
            className: 'inst'
        },
        {
            href: 'linkedin',
            className: 'lin'
        },
        {
            href: 'pinterest',
            className: 'pt'
        }
    ];
    private followStates = ['studio-followers', 'studio-following'];

    constructor(
        private $rootScope: ng.IRootScopeService,
        private $element: ng.IAugmentedJQuery,
        private $state: ng.ui.IStateService
    ) {
        const footer = $element[0];
        const windowHeight = window.innerHeight;
        window.addEventListener(
            'scroll',
            _.throttle(
                () =>
                    Utils.rAF(() => {
                        const scrollTopDocument =
                            window.scrollY || window.pageYOffset;
                        const action =
                            scrollTopDocument > windowHeight * 3
                                ? 'add'
                                : 'remove';
                        footer.classList[action]('fixed');
                    }),
                250
            )
        );

        this.$rootScope.$on('$stateChangeStart', () =>
            footer.classList.remove('shown')
        );
        this.$rootScope.$on(
            '$stateChangeSuccess',
            () => (this.product = Utils.getProduct())
        );
        this.$rootScope.$on('$projects:shownAll', () =>
            footer.classList.add('shown')
        );
        this.$rootScope.$on(
            '$following:loaded',
            () =>
                this.followStates.includes(this.$state.current.name) &&
                footer.classList.add('shown')
        );
    }
}
directives.component('anmFooter', {
    controller: FooterCtrl,
    templateUrl: require('footer.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/Footer.ts